
import { getServiceInstance } from 'app/multi-contexts/modules/root/root.application';
import { ExposureControlService } from 'app/services/exposure-control/base-exposure-control.service';
import { GuardFeatures } from 'app/services/exposure-control/ec.typings';
import { GlobalVariables } from 'app/services/globals';
import { sanitizeAndFormatString } from 'app/shared/utils/string.util';
import { IValidationContext, IViolation, Metamodel, TriggerDependency, TriggerProperties, TumblingWindowTriggerProperties, tumblingWindowTriggerValidators } from 'shell-models-lib';

tumblingWindowTriggerValidators.validateTriggerDependencies = async (triggerProperties: TriggerProperties, context: IValidationContext): Promise<IViolation[]> => {
    const violations: IViolation[] = [];
    if (Metamodel.modelOf(triggerProperties).name === TumblingWindowTriggerProperties.MODEL.name) {
        let updatedDependsOn: TriggerDependency[] = [];
        const properties = triggerProperties as TumblingWindowTriggerProperties;
        const ecSvc = (await getServiceInstance<ExposureControlService>(context.contextData, 'ExposureControlService'));
        if (properties && properties.dependsOn) {
            updatedDependsOn = properties.dependsOn.filter((item) => item.trigger);
            const trigger = properties?.owner;
            updatedDependsOn.forEach((item) => {
                if (item.trigger.name === trigger.named.name) {
                    // verify if negative offset is set for self dependency
                    if (!item.offset || !item.offset.startsWith('-')) {
                        violations.push({
                            message: () => stringResources.Trigger_TumblingWindowSelfDependencyMustHaveNegativeOffset
                        });
                    }
                }
                // verify the combined window / offset size do not exceed the maximum lookback period of 45 days
                if (ecSvc.getCachedFeatureValue<boolean>(GuardFeatures.ADFTumblingWindowTriggerValidateDependencySize)) {
                    if (TumblingWindowTriggerProperties.toHours(item.offset) < -TumblingWindowTriggerProperties.maxHours || TumblingWindowTriggerProperties.toHours(item.windowSize) > TumblingWindowTriggerProperties.maxHours ||
                        (TumblingWindowTriggerProperties.toHours(item.offset) + TumblingWindowTriggerProperties.toHours(item.windowSize)) > TumblingWindowTriggerProperties.maxHours) {
                        violations.push({
                            message: () => sanitizeAndFormatString(stringResources.Trigger_TumblingWindowDependencyTimeTooLong, item.name)
                        });
                    }
                }
            });

            const maxDependencyCountAllowed = ecSvc.getCombinedFeatureValue(
                GuardFeatures.ADFMaxTumblingWindowDependencyCount, GlobalVariables.tumblingWindowDependencyCount,
                (response) => typeof response === 'string' ? Number.parseInt(response, 10) : undefined
            );
            if (updatedDependsOn.length > maxDependencyCountAllowed) {
                violations.push({
                    message: () => sanitizeAndFormatString(stringResources.Trigger_TumblingWindowMaxDependencyExceeded, triggerProperties.named.name, `${updatedDependsOn.length}`, `${maxDependencyCountAllowed}`)
                });
            }
        }
    }
    return violations;
};
export { TumblingWindowTriggerProperties } from 'shell-models-lib';
